import { createSlice } from '@reduxjs/toolkit'

// declear all the initial value to the state
const initialState = {
  value: 0,
  access_token : "",
  refresh_token : "",
  user_details : {},
}

export const counterSlice = createSlice({
  name: 'authinfo',
  initialState,
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },

    setAccessToken: (state, action) => {
        state.access_token = action.payload;
      },
      setRefreshToken: (state, action) => {
        state.refresh_token = action.payload;
      },
      setUserDetails: (state, action) => {
        state.user_details = action.payload;
      },
  },
})

// Action creators are generated for each case reducer function
export const { increment, decrement, incrementByAmount ,setAccessToken ,setRefreshToken , setUserDetails } = counterSlice.actions

export default counterSlice.reducer